module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lumi-column"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-986c9ab8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/LumiColumn.vue
// module id = 70
// module chunks = 0